import { writable } from 'svelte/store';
// Create a store to keep track cta subnav visibility
export const ctaSubnavButtonsAreVisibleStore = writable(false);
// Function to update cta subnav visibility
export function setCtaSubnavButtonsVisibility({ renderCta, renderSecondaryCta, ctaIsVisible, isSticky, hiddenUntilScrolled, }) {
    ctaSubnavButtonsAreVisibleStore.set(
    // CTA or Secondary CTA will be rendered
    ((renderCta && ctaIsVisible) || renderSecondaryCta) &&
        // And the CtaSubnav shouldn't be hidden
        ((isSticky && hiddenUntilScrolled) || !hiddenUntilScrolled));
}
